<template>
    <b-form-group
            class="c-instance-selector"
            :label-for="id"
            :key="'instance_' + id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <table class="table">
            <thead>
                <tr>
                    <th>{{description}}</th>
                    <th class="text-right">
                        <b-link v-if="dataValue.length > 0"  @click="onResetClick"  href="#" class="card-header-action btn-setting mt-2">{{Core.Definition.getDefinition('Réinitialiser')}}</b-link>
                        <b-link @click="onSelectClick" href="#" class="card-header-action btn-setting mt-2">
                            {{Core.Definition.getDefinition('Sélectionner')}}
                        </b-link>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="value, valueIndex in dataValue">
                    <td>
                        {{value.label}}
                    </td>
                    <td width="5%">
                        <b-button @click="onClickRemoveValue(valueIndex)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></b-button>
                    </td>
                </tr>
                <tr v-if="dataValue.length == 0">
                    <td colspan="2">
                        {{emptyMessage}}
                    </td>
                </tr>
            </tbody>
        </table>

        <ModalInstanceSelector
                ref="modalInstanceSelector"
                :id="'instanceSelector_' + id"
                :key="'instanceSelector_' + id"
                :root="instanceSelector.root"
                :searchFormStructure="instanceSelector.searchFormStructure"
                :multiple="false"
                size="md"
                v-model="dataValues"
                :searchArgs="searchArgs"
                :options="instanceSelector.options"
                :columns="Core.Array.newArray(instanceSelector.columns)"></ModalInstanceSelector>
        <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
            {{invalidFeedbackMessage}}
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
    import ModalInstanceSelector from './ModalInstanceSelector'
    export default {
        name: 'InputInstanceSelector',
        components: {
            ModalInstanceSelector,
        },
        props: {
            required: {
                type: Boolean,
                default: false
            },
            id: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            },
            labelCols: {
                type: Number,
                default: 0
            },
            readOnly: {
                type: Boolean,
                default: false
            },
            invalidFeedbackMessage: {
                type: String,
                default: ''
            },
            emptyMessage: {
                type: String,
                default: '',
                required: true
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            instanceSelector: {
                type: Object,
                default: function () {
                    return {
                        root: '',
                        searchFormStructure: {},
                        data: {},
                        options: {
                            pagination: true,
                            header: true,
                            responsive: false,
                            striped: true,
                            headerStyle: '1',
                            emptyText: Core.Definition.getDefinition('Aucun élément à afficher'),
                            borderVariant: 'white',
                            noBody: true
                        },
                        columns: [],
                        label: '',
                        id: ''
                    }
                },
                required: true
            },
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue(val) {
                this.$emit('input', val)
            },
            dataValues: {
                handler(val) {

                    let values = this.dataValue

                    let value = {
                        id: '',
                        label: ''
                    }
                    if (val[0] !== undefined && val[0].instance !== undefined) {
                        if (this.instanceSelector.id !== undefined) {
                            let ids = []
                            if (Array.isArray(this.instanceSelector.id)) {
                                for(let id in this.instanceSelector.id) {
                                    id = this.instanceSelector.id[id]
                                    if (undefined !== val[0].instance[id]) {
                                        ids.push(val[0].instance[id])
                                    }
                                }
                                value.id = ids.join(',')
                            } else {
                                if (undefined !== val[0].instance[this.instanceSelector.id]) {
                                    value.id = val[0].instance[this.instanceSelector.id]
                                }
                            }

                            let labels = []
                            if (Array.isArray(this.instanceSelector.label)) {
                                for(let label in this.instanceSelector.label) {
                                    label = this.instanceSelector.label[label]
                                    if (undefined !== val[0].instance[label]) {
                                        labels.push(val[0].instance[label])
                                    }
                                }
                                value.label = labels.join(' ')
                            } else {
                                if (undefined !== val[0].instance[this.instanceSelector.label]) {
                                    value.label = val[0].instance[this.instanceSelector.label]
                                }
                            }
                        }
                    }
                    values.push(value)

                    this.dataValue = Core.Array.newArray(values)
                }
            }
        },
        mounted() {
            this.dataValue = this.value
        },
        data: () => {
            return {
                Core: window.Core,
                dataId: '',
                dataValue: {
                    id: '',
                    label: ''
                },
                dataValues: []
            }
        },
        methods: {
            onSelectClick() {
                this.$refs.modalInstanceSelector.open = true
            },
            onResetClick() {
                this.dataValue = []
            },
            onClickRemoveValue(valueIndex) {
                this.dataValue.splice(valueIndex, 1)
            }
        }
    }
</script>